import { z } from "@/zod";
import { dictionary } from "@/schemas/dictionary";

const provinceSchema = dictionary.extend({
  nfz_code: z.string().min(1),
  nfz_description: z.string().min(1),
});

export const province = provinceSchema.readonly();
export const writeProvince = provinceSchema.omit({ id: true });
